import Vue from "vue";
import Component from "vue-class-component";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem, PulldownItem } from "@/types";
import { Prop, Ref } from "vue-property-decorator";
import DiseaseSettingDialog from "@/components/medicalEdit/DiseaseSettingDialog.vue";

@Component
export default class MedicalSpecificationBase extends Vue {
  @Ref("diseaseDialog") readonly diseaseDialog!: DiseaseSettingDialog; //疾病ダイアログ

  @Prop() tab!: MedicalSpecification;
  @Prop() sex_items!: SelectItem[]; //性別選択アイテムリスト
  @Prop() beppyou_items!: SelectItem[]; //別表選択アイテムリスト
  @Prop() visit_end_status_items!: SelectItem[]; //訪問終了の状況アイテムリスト
  @Prop() die_place_items!: SelectItem[]; //死亡場所ムリスト
  @Prop() ins_type_items!: PulldownItem[]; //保険種類アイテムリスト
  @Prop() ins_multi_items!: PulldownItem[]; //保険併用アイテムリスト
  @Prop() ins_div_items!: PulldownItem[]; //保険区分アイテムリスト
  @Prop() reduction_unit_items!: SelectItem[]; //減額単位アイテムリスト
  @Prop() reduction_type_items!: SelectItem[]; //減額種類アイテムリスト
  @Prop() school_enter_items!: SelectItem[]; //学校情報提供先アイテムリスト
  @Prop() visit_count_items!: PulldownItem[]; //訪問回数アイテムリスト
  @Prop() indicate_day_items!: PulldownItem[]; //特指示アイテムリスト
  @Prop() long_day_items!: PulldownItem[]; //長時間アイテムリスト
  @Prop() multi_day_items!: PulldownItem[]; //複数日アイテムリスト
  @Prop() same_building_day_items!: PulldownItem[]; //同一建物アイテムリスト
  @Prop() same_emergency_day_items!: PulldownItem[]; //同一緊急アイテムリスト
  @Prop() special_day_items!: PulldownItem[]; //専門アイテムリスト

  selectItemTab = 0; //選択中のタブ

  openDialog() {
    this.diseaseDialog.open(this.tab.beppyou_code);
  }

  changealltotal() {
    let total = 0;
    this.tab.basics.forEach(item => {
      total += item.total_money;
    });
    this.tab.minds.forEach(item => {
      total += item.total_money;
    });
    this.tab.managements.forEach(item => {
      total += item.total_money;
    });

    if (
      this.tab.ins_type == 3 &&
      (this.tab.ins_multi == 1 ||
        this.tab.is_hidden_2nd_pub_money ||
        this.tab.is_target_visits_same_for_pub_moneys)
    ) {
      // 公費単独かつ公費が１つまたは公費②を隠す場合または公費①②の対象訪問が同じ場合は公①に合算（保険なしで公費2つの時はそれぞれの公費金額欄にそれぞれの公費金額を記載する）
      this.tab.total_invoice2 = total;
    } else {
      this.tab.total_invoice1 = total;
    }
  }

  changepublicmoney1() {
    let total = 0;
    this.tab.basics.forEach(item => {
      total += item.public_money1;
    });
    this.tab.minds.forEach(item => {
      total += item.public_money1;
    });
    this.tab.managements.forEach(item => {
      total += item.public_money1;
    });
    if (
      this.tab.ins_type == 3 &&
      (this.tab.ins_multi == 1 ||
        this.tab.is_hidden_2nd_pub_money ||
        this.tab.is_target_visits_same_for_pub_moneys)
    ) {
      // 公費単独かつ公費が１つまたは公費②を隠す場合または公費①②の対象訪問が同じ場合は無視する
      return;
    }
    this.tab.total_invoice2 = total;
  }

  changepublicmoney2() {
    let total = 0;
    this.tab.basics.forEach(item => {
      total += item.public_money2;
    });
    this.tab.minds.forEach(item => {
      total += item.public_money2;
    });
    this.tab.managements.forEach(item => {
      total += item.public_money2;
    });
    this.tab.total_invoice3 = total;
  }
}
